import { Observable, Observer, of } from 'rxjs';

export function loadScript(src: string): Promise<void> {
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement('script');

    script.onload = () => resolve();
    script.onerror = () => reject();
    script.src = src;

    document.head.appendChild(script);
  });
}

export function loadScriptObservable(id: string, src: string): Observable<boolean> {
  if (typeof window[id] === 'undefined') {
    const data$: Observable<boolean> = new Observable((observer: Observer<boolean>) => {
      const script: any = document.createElement('script');
      script.src = src;
      script.type = 'text/javascript';
      if (script.readyState) {
        // IE
        script.onreadystatechange = () => {
          if (script.readyState === 'loaded' || script.readyState === 'complete') {
            script.onreadystatechange = null;
            setTimeout(() => {
              observer.next(true);
              observer.complete();
            });
          }
        };
      } else {
        script.onload = () => {
          observer.next(false);
          observer.complete();
        };
      }
      document.head.appendChild(script);
    });
    return data$;
  } else {
    return of(true);
    // lib already registered
  }
}

export function pollUntilClose(window: Window): Promise<void> {
  return new Promise<void>((resolve) => {
    const interval = setInterval(() => {
      if (window.closed) {
        clearInterval(interval);
        resolve();
      }
    }, 500);
  });
}

export function addOverflowHidden() {
  document.body.style.overflow = 'hidden';
}

export function removeOverflowHidden() {
  document.body.style.overflow = '';
}

export function hideIntercom() {
  document.querySelector('.intercom-lightweight-app')?.classList.add('hidden');
}
export function showIntercom() {
  document.querySelector('.intercom-lightweight-app')?.classList.remove('hidden');
}

export function setHeaderZindex() {
  const header = document.querySelector<HTMLElement>('nz-header');
  if (header) {
    header.style.zIndex = '1002';
  }
}
export function unsetHeaderZindex() {
  const header = document.querySelector<HTMLElement>('nz-header');
  if (header) {
    header.style.zIndex = null;
  }
}

export const getCookieByKey = (key: string): string | null => {
  key += '=';
  let cookieValue = null;
  if (document.cookie && document.cookie !== '') {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i += 1) {
      const cookie = cookies[i].trim();
      if (cookie.startsWith(key)) {
        cookieValue = decodeURIComponent(cookie.replace(key, ''));
        break;
      }
    }
  }
  return cookieValue;
};
export function RemoveLoader() {
  let elem = document.getElementById('app-loading');
  elem?.parentNode?.removeChild(elem);
  elem = null;
}

export function SetBrowserAgentClass() {
  const global = window as any;

  // Firefox 1.0+
  const isFirefox = typeof global.InstallTrigger !== 'undefined';

  // Safari 3.0+
  const isSafari = navigator.userAgent.indexOf('Safari') !== -1 && navigator.userAgent.indexOf('Chrome') === -1;

  // Internet Explorer 6-11
  const isIE = !!window['MSInputMethodContext'] && !!document['documentMode'];

  // Edge 20+
  const isEdge = /Edge\/\d./i.test(navigator.userAgent);

  // Chrome 1+
  const isChrome = !!global.chrome;

  if (isFirefox) {
    document.body.classList.add('firefox');
  }
  if (isSafari) {
    document.body.classList.add('safari');
  }
  if (isIE && !isEdge) {
    document.body.classList.add('ie');
  }
  if (isEdge) {
    document.body.classList.add('edge');
  }
  if (isChrome) {
    document.body.classList.add('chrome');
  }
}
export function SetOSClass() {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;
  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'mac';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'ios';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'windows';
  } else if (/Android/.test(userAgent)) {
    os = 'android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'linux';
  }
  return document.body.classList.add(os);
}

export function isTourEnabled(): boolean {
  return !!document.querySelector('adspt-header .wizard');
}
